export const SET_STRIPE_INFO_PENDING = 'SET_STRIPE_INFO_PENDING'
export const SET_STRIPE_INFO = 'SET_STRIPE_INFO'
export const SET_STRIPE_INFO_ERROR = 'SET_STRIPE_INFO_ERROR'
